import { Component, OnInit } from "@angular/core";

import { BaseControlComponent } from "../../../../../../form-controls/components/base-control/base-control.component";
import { ContextInteractionService } from "../../../../../../form-controls/services/context-interaction.service";


@Component({
    selector: "app-data-query-button-display-config",
    templateUrl: "./data-query-button-display-config.component.html",
    styleUrls: ["./data-query-button-display-config.component.scss"],
    standalone: false
})
export class DataQueryButtonDisplayConfigComponent extends BaseControlComponent implements OnInit {

    static componentName = "DataQueryButtonDisplayConfigComponent";

    displayOptions = [{ id: "selectable", value: "Selectable Data Table" }, { id: "table", value: "Data Table" }, { id: "text", value: "Text" }, { id: "context", value: "Hide" }];

    constructor(public readonly contextService: ContextInteractionService) { super(contextService); }

    get disableLimitBox(): boolean {
        return (this.componentData.config.limitSelections !== "true");
    }

    get dataContext(): string {
        if (this.componentData.contextTarget) {
            return this.componentData.contextTarget;
        }
        return "No context target defined for question.  Query results will not be retained.";
    }

    ngOnInit() {
        if (this.componentData.config.runOnInit === undefined || this.componentData.config.runOnInit === null) {
            this.componentData.config.runOnInit = false;
        }
    }

}
